import { GET_AVAILABLE_DEVICE_VERSION } from "./api-url.constants";
import { jsonFetch } from "@/lib/helpers";

export const getAvailableDeviceVersion = async (): Promise<string> => {
  const availableDeviceVersion = await jsonFetch<{ data: string }>(GET_AVAILABLE_DEVICE_VERSION);
  return availableDeviceVersion.data;
};
